(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content_tabs"] && !Shopify.designMode) return;
  try {
    
  
tabs = document.querySelectorAll('.tab');
tabContents = document.querySelectorAll('.tab-content');

tabs.forEach(function(tab){
  tab.addEventListener('click', function(){
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    tabContents.forEach(function(content){
      content.classList.remove('active');
    });
    tabs.forEach(function(tab){
      tab.classList.remove('active');
    });

    this.classList.add('active');
    content.classList.add('active');
  });
});

mobileTabs = document.querySelectorAll('.mobile-tab');

mobileTabs.forEach(function(tab){
  tab.addEventListener('click', function(){
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    mobileTabs.forEach(function(tab){
      tab.classList.remove('active');
    });

    this.classList.add('active');

    document.querySelectorAll('.mobile-tab-content').forEach(function(content){
      content.style.display = 'none';
    });

    content.style.display = 'block';
  });
});








  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["internal-navigation-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const navLinks = document.querySelectorAll('.landing-nav__link');

    navLinks.forEach(link => {
      link.addEventListener('click', function() {
        navLinks.forEach(item => item.classList.remove('is-active'));
        this.classList.add('is-active');
      });
    });

    let lastScrollPosition = 0;
    const body = document.body;

    window.addEventListener('scroll', function() {
      let currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      // Ignore scroll bouncing at the very top
      if (currentScrollPosition <= 0) {
        body.classList.remove('scrolling-up');
        return;
      }

      // Determine scroll direction
      if (currentScrollPosition > lastScrollPosition) {
        // User is scrolling down
        body.classList.remove('scrolling-up');
        body.classList.add('scrolling-down');
      } else {
        // User is scrolling up
        body.classList.add('scrolling-up');
        body.classList.remove('scrolling-down');
      }
      
      lastScrollPosition = currentScrollPosition;
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-application-steps"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const steps = document.querySelectorAll('[data-step-container]');

  steps.forEach(step => {
    step.addEventListener('click', () => {
      const targetIdentifier = step.getAttribute('data-step-container');

      steps.forEach(t => t.classList.remove('active'));

      step.classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-content-tabs"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('[data-tab-title]');
  const contents = document.querySelectorAll('[data-tab-content]');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetIdentifier = tab.getAttribute('data-tab-title');

      tabs.forEach(t => t.classList.remove('active'));
      
      contents.forEach(c => c.classList.remove('active'));

      tab.classList.add('active');

      const matchingContent = document.querySelector(`[data-tab-content="${targetIdentifier}"]`);
      if (matchingContent) {
        matchingContent.classList.add('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-darl-overtime-old"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const mainImages = [
        document.getElementById("skinMainImage-1"),
        document.getElementById("skinMainImage-2"),
        document.getElementById("skinMainImage-3")
    ];

    const ageSections = document.querySelectorAll(".skin-changes-overtime-age-section");

    window.changeImage = function(index, clickedElement) {
        // Prevents action if the clicked element is already active
        if (clickedElement.classList.contains('active')) {
            return;
        }

        // Update main images
        mainImages.forEach((img, i) => {
            img.style.display = i === (index - 1) ? 'block' : 'none';
            img.style.opacity = i === (index - 1) ? 1 : 0;
        });

        // Update age labels
        document.querySelectorAll(".skin-changes-overtime-age-label").forEach((label, i) => {
            label.classList.toggle("active", i === (index - 1));
            label.innerHTML = i === (index - 1) ? `AGE ${i * 20 + 20}` : `${i * 20 + 20}`;
        });

        // Update age thumbnails
        ageSections.forEach((section, i) => {
            section.classList.toggle("active", i === (index - 1));
        });

        // Set the clicked thumbnail to active
        const ageImages = document.querySelectorAll(".skin-changes-overtime-age-image");
        ageImages.forEach((image, i) => {
            image.classList.toggle("active", i === (index - 1));
        });
    };

    // Set the default state on page load for AGE 20
    mainImages[0].style.display = 'block'; // Show the AGE 20 image
    mainImages[0].style.opacity = 1; // Set opacity to 1 for visibility

    // Set the default label states
    const labels = document.querySelectorAll(".skin-changes-overtime-age-label");
    labels[0].classList.add("active"); // Activate AGE 20 label
    labels[0].innerHTML = "AGE 20"; // Set the text for active label

    // Set inactive states for the other labels
    for (let i = 1; i < labels.length; i++) {
        labels[i].classList.remove("active");
        labels[i].innerHTML = `${i * 20 + 20}`; // Show just the age number
    }

    // Activate AGE 20 thumbnail
    ageSections[0].classList.add("active"); // Set the first thumbnail as active
    const ageImages = document.querySelectorAll(".skin-changes-overtime-age-image");
    ageImages[0].classList.add("active"); // Add active class to AGE 20 thumbnail
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-darl-overtime"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const mainImages = [
        document.getElementById("skinMainImage-1"),
        document.getElementById("skinMainImage-2"),
        document.getElementById("skinMainImage-3")
    ];

    const ageSections = document.querySelectorAll(".skin-changes-overtime-age-section");
    const labels = document.querySelectorAll(".skin-changes-overtime-age-label");
    const ageImages = document.querySelectorAll(".skin-changes-overtime-age-image");

    // Selecciona todas las flechas
    const leftArrows = document.querySelectorAll(".icon-caret.left");
    const rightArrows = document.querySelectorAll(".icon-caret.right");

    let currentIndex = 0; // Default to the first image

    function updateActiveElements(index) {
        // Update main images
        mainImages.forEach((img, i) => {
            img.style.display = i === index ? "block" : "none";
            img.style.opacity = i === index ? 1 : 0;
        });

        // Highlight the active label
        labels.forEach((label, i) => {
            label.classList.toggle("active", i === index);
        });

        // Highlight the active thumbnail
        ageSections.forEach((section, i) => {
            section.classList.toggle("active", i === index);
        });

        ageImages.forEach((image, i) => {
            image.classList.toggle("active", i === index);
        });
    }

    function changeImage(index) {
        currentIndex = index - 1; // Convert 1-based index to 0-based
        updateActiveElements(currentIndex);
    }

    function changeImageByArrow(direction) {
        currentIndex += direction;
        if (currentIndex < 0) currentIndex = mainImages.length - 1; // Loop back to the last image
        if (currentIndex >= mainImages.length) currentIndex = 0; // Loop back to the first image
        updateActiveElements(currentIndex);
    }

    // Set initial state
    updateActiveElements(currentIndex);

    // Agregar eventos para todas las flechas
    leftArrows.forEach(arrow => {
        arrow.addEventListener("click", () => changeImageByArrow(-1));
    });

    rightArrows.forEach(arrow => {
        arrow.addEventListener("click", () => changeImageByArrow(1));
    });

    // Expose the function for manual label clicks
    window.changeImage = changeImage;
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-darl-science-approach"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Select elements within the science-approach section
  const section = document.querySelector('.science-approach');
  if (!section) return;

  const imageButtons = section.querySelectorAll('.image-buttons button');
  const imageButtonsMobile = section.querySelectorAll('.image-buttons-mobile button'); // Add mobile buttons
  const bottomButtons = section.querySelectorAll('.bottom-buttons button');
  const textBoxes = section.querySelectorAll('.text-box');

  function setActiveButton(target) {
    // Remove active class from all buttons
    [...imageButtons, ...imageButtonsMobile, ...bottomButtons].forEach(btn => btn.classList.remove('active'));

    // Add active class to all buttons with the matching data-target
    section.querySelectorAll(`button[data-target="${target}"]`).forEach(btn => btn.classList.add('active'));
    
    // Hide all text boxes and show the selected one
    textBoxes.forEach(box => box.style.display = 'none');
    const activeTextBox = section.querySelector(`#text-${target}`);
    if (activeTextBox) activeTextBox.style.display = 'block';
  }

  // Add event listeners to all sets of buttons
  [...imageButtons, ...imageButtonsMobile, ...bottomButtons].forEach(button => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-target');
      setActiveButton(target);
    });
  });

  // Set the default active button and text box to be 1
  setActiveButton('1');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-darl-skincare-matureskin"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const dropdownRows = document.querySelectorAll('.dropdowns-skincare .dropdown-row');

  dropdownRows.forEach(row => {
    const title = row.querySelector('.dropdown-title');
    const text = row.querySelector('.dropdown-text');
    const caret = row.querySelector('.icon-caret');

    title.addEventListener('click', () => {
      const isOpen = caret.classList.contains('open');

      // Close all dropdowns
      dropdownRows.forEach(otherRow => {
        const otherText = otherRow.querySelector('.dropdown-text');
        const otherCaret = otherRow.querySelector('.icon-caret');

        otherText.style.display = 'none';
        otherCaret.classList.remove('open');
        otherCaret.classList.add('closed');
      });

      // Toggle the clicked dropdown
      if (!isOpen) {
        text.style.display = 'block';
        caret.classList.remove('closed');
        caret.classList.add('open');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-darl-skinroutine"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const dropdownTitles = document.querySelectorAll(".the-darl-skinroutine .dropdown-title");
    const dropdownContents = document.querySelectorAll(".the-darl-skinroutine .dropdown-content");
    const products = document.querySelectorAll(".the-darl-skinroutine .products-imgs > div");
    const mobileTabs = document.querySelectorAll(".routine-mobile .steps-tab .tab"); // Mobile tabs
    const mobileDropdowns = document.querySelectorAll(".routine-mobile .dropdown-mobile");

    let activeIndex = 0; // Start with the first dropdown open by default

    // Function to open a specific dropdown and show the corresponding product
    function openDropdown(index) {
        dropdownContents.forEach((content, i) => {
            if (i === index) {
                content.style.display = "block";  // Show the active dropdown content
                dropdownTitles[i].querySelector(".icon-caret").classList.add("open");
                dropdownTitles[i].querySelector(".icon-caret").classList.remove("closed");
            } else {
                content.style.display = "none";  // Hide inactive dropdown content
                dropdownTitles[i].querySelector(".icon-caret").classList.remove("open");
                dropdownTitles[i].querySelector(".icon-caret").classList.add("closed");
            }
        });

        // Remove 'active' class from all product sections
        products.forEach((product) => {
            product.classList.remove("active");
            product.style.opacity = "0";
            product.style.visibility = "hidden";
        });

        // Add 'active' class to the corresponding product section
        products[index].classList.add("active");
        products[index].style.opacity = "1";
        products[index].style.visibility = "visible";
    }

    // Mobile function to open a specific tab and show corresponding product
    function openMobileTab(index) {
        mobileDropdowns.forEach((dropdown, i) => {
            dropdown.style.display = i === index ? "block" : "none"; // Show active dropdown
        });

        // Update the products images for the mobile view
        products.forEach((product, i) => {
            product.classList.toggle("active", i === index);
            product.style.opacity = i === index ? "1" : "0";
            product.style.visibility = i === index ? "visible" : "hidden";
        });

        // Update active class on tabs
        mobileTabs.forEach((tab, i) => {
            tab.classList.toggle("active", i === index);
        });
    }

    // Open the first dropdown and mobile tab by default
    openDropdown(activeIndex);
    openMobileTab(activeIndex);

    // Add click event listeners to dropdown titles for desktop
    dropdownTitles.forEach((title, index) => {
        title.addEventListener("click", function() {
            openDropdown(index);
        });
    });

    // Add click event listeners to mobile tabs
    mobileTabs.forEach((tab, index) => {
        tab.addEventListener("click", function() {
            openMobileTab(index);
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-darl-two-col-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const lazyVideos = [].slice.call(document.querySelectorAll("video.lazy-bg-video"));

  if ("IntersectionObserver" in window) {
    const videoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          const videoElement = video.target;
          const source = videoElement.querySelector("source");
          
          if (source && source.dataset.src) {
            source.src = source.dataset.src;
            videoElement.load();
          }
          
          videoElement.play().catch(error => {
            console.log("El autoplay fue bloqueado o el video aún no está listo:", error);
          });

          videoObserver.unobserve(videoElement);
        }
      });
    }, {
      rootMargin: "0px 0px 100px 0px"
    });

    lazyVideos.forEach(function(lazyVideo) {
      videoObserver.observe(lazyVideo);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
